<template>
  <div :class="className" :style="'grid-row: ' + row + '; grid-column: ' + column + ';'">
    {{ stock }}
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      className: 'ok',
      stock: '',
      row: 0,
      column: 0,
    }
  },
  mounted: function () {
    this.setClassName()
    this.setRow()
    this.setColumn()
    this.setStock()
  },
  methods: {
    setClassName() {
      if (this.count === 0) {
        this.className = 'ng'
      }
    },
    setRow() {
      this.row = (this.index % 3) + 1
    },
    // `index` runs over 7 dates x 3 stock rows in date order (see stockGridData in
    // YamoriReservationCalendar.vue), so date N is column N + 1. The assignment used
    // to be missing, which left `column` at 0 and emitted the invalid declaration
    // `grid-column: 0`; the browser dropped it and auto-placed the cell instead. That
    // happened to land on the same column as long as every date carries exactly three
    // stock rows, so nothing looked wrong -- but the placement was luck, not design.
    setColumn() {
      this.column = Math.floor(this.index / 3) + 1
    },
    setStock() {
      if (this.count >= 1) {
        this.stock = this.count
      }
    },
  },
}
</script>
